import React, { useState } from "react";
import { Button } from "@clarkinc/zest-design-system/ui";
import { CustomerReviews, FilteredBy, ProductReviewDetail } from "../../reviewModels";
import { sendGtmEvent, clearGa4EventInDataLayer } from "../../../../analytics/definitions";
import MultipleVariationFilter from "../MultipleVariationFilter";
import RatingsFilter from "../RatingsFilter";
export const reviewAggregationToolBarId = "review-aggregation-toolbar";
export interface ReviewAggregationToolbarProps {
  reviews: CustomerReviews;
  reviewLink: string;
  isProductReviewPage?: boolean;
  allProductReviews: readonly ProductReviewDetail[];
  filteredBy: FilteredBy;
  sortedAndFilteredReviews: ProductReviewDetail[];
  filterByChangeHandler: (filteredBy?: FilteredBy, gtmLabel?: string) => void;
  sortByChangeHandler?: (sortBy: string) => void;
  stickyHeaderCollapsed?: boolean;
}
const ReviewAggregationToolbar = ({
  reviews,
  reviewLink,
  isProductReviewPage = false,
  allProductReviews,
  filteredBy,
  sortedAndFilteredReviews,
  filterByChangeHandler,
  sortByChangeHandler,
  stickyHeaderCollapsed
}: ReviewAggregationToolbarProps) => {
  const totalReviews = allProductReviews.length;
  const [showAllMobileFilters, setShowAllMobileFilters] = useState(false);
  const filterToggleLabel = showAllMobileFilters ? "Hide Filters" : "Show Filters";
  const filterToggleTestId = showAllMobileFilters ? "hide-review-filters" : "show-review-filters";
  const showingReviews = sortedAndFilteredReviews.length;
  const sortChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const reviewSortBy = event.target.value;
    sortByChangeHandler?.(reviewSortBy);
    clearGa4EventInDataLayer();
    sendGtmEvent({
      event: "ga4_event",
      eventName: "Customer Reviews - Sort By Dropdown Change",
      eventLabel: `Sort By: ${reviewSortBy}`
    });
  };
  return <div className={`review-aggregation-toolbar v2 ${isProductReviewPage || stickyHeaderCollapsed ? "scroll-mt-4" : "scroll-mt-28"}`} id={reviewAggregationToolBarId} data-sentry-component="ReviewAggregationToolbar" data-sentry-source-file="index.tsx">
      {totalReviews > 0 && <>
          <div className="box bg-white rounded mb-4 px-0 xs:px-4 p-4 flex flex-wrap gap-4 xxxl:px-4 xs:mt-[0_!important] [@media(min-width:150px)]:-mt-[15px]">
            <div className="flex flex-col w-full px-4 xs:px-0 xs:w-auto box-border">
              <label className="review-aggregation__label block" htmlFor="sortby">
                Sort By
              </label>
              <select className="suffix_dropdown configure item_number text-sm w-full xs:w-36 md:w-44 lg:w-[195px]" id="sortby" name="SortBy" onChange={sortChangeHandler} data-testid="review-sort-dropdown" defaultValue={isProductReviewPage ? "date_newest" : undefined}>
                <option value="most_helpful">Most Helpful</option>
                <option value="highest_rated">Highest Rating</option>
                <option value="lowest_rated">Lowest Rating</option>
                <option value="date_newest">Date: Newest</option>
                <option value="date_oldest">Date: Oldest</option>
                <option value="with_media">With Photos & Videos</option>
              </select>
            </div>
            <MultipleVariationFilter onVariationTypeChange={filterByChangeHandler} variationOptions={reviews.variationOptions} filteredBy={filteredBy} className={showAllMobileFilters ? "" : "hidden xs:block"} />
            <RatingsFilter onRatingChange={filterByChangeHandler} filteredBy={filteredBy} className={showAllMobileFilters ? "" : "hidden xs:block"} />
            <div className="w-full xs:w-auto flex lt:py-3 xs:pb-0 lt:pt-[1.2rem] pl-4 xs:pl-0 box-border xs:basis-full md:basis-auto">
              <div className="xs:hidden w-full m-auto min-h-7">
                <Button variant="plain" theme="wss" size="medium" onClick={() => setShowAllMobileFilters(!showAllMobileFilters)} data-testid={filterToggleTestId}>
                  <span>{filterToggleLabel}</span>
                </Button>
              </div>
              {(filteredBy.rating !== "all" || filteredBy.variation.type) && <div className="flex xs:flex-none justify-end w-full xs:w-auto m-auto xs:m-0 xs:items-end min-h-7">
                  <div className="xs:float-left pr-4 xs:pr-0">
                    <Button variant="plain" theme="wss" size="medium" onClick={() => filterByChangeHandler()} data-testid="clear-filters">
                      <span className="text-green-500 text-base font-semibold">
                        Clear Filters
                      </span>
                    </Button>
                  </div>
                </div>}
            </div>
          </div>

          <div className="flex flex-wrap justify-between items-end w-full mt-4 sm:mt-0">
            <div className="ml-2 font-normal text-sm-3/4 leading-1.25 self-end text-left text-gray-800">
              <span>{`Showing ${showingReviews} of ${totalReviews} ${totalReviews > 1 ? "reviews" : "review"}`}</span>
            </div>
            {totalReviews >= 40 && reviewLink.length > 0 && <div className=" mr-2 font-normal text-sm-3/4 leading-1.25 text-right text-green-500">
                <a href={reviewLink} data-testid="see-all-reviews-link" className="text-green-600">
                  <span>{`See All ${totalReviews} Reviews`}</span>
                </a>
              </div>}
          </div>
        </>}
    </div>;
};
export default ReviewAggregationToolbar;